/**
 * King Living Textarea Theme
 *
 * Global textarea styling system:
 * - White background for all states
 * - Consistent with input field styling
 * - Matches Field component textarea styles
 *
 * @override Extends Chakra UI Textarea theme
 */

const Textarea = {
  baseStyle: {
    backgroundColor: 'white',
    _focus: {
      backgroundColor: 'white',
    },
    _hover: {
      backgroundColor: 'white',
    },
    _disabled: {
      backgroundColor: 'brandColors.disabledBG',
    },
  },
};

export default Textarea;
